export default "__VITE_ASSET__Daelra$v__"